import React from "react";

import LegalDocument from "../legal_document";
import legalCgu from "../content/legal_cgu";

const GeneralTerms = () => <LegalDocument layout={legalCgu} />;

export default GeneralTerms;
